import React from 'react'
import icon from './svgs/UsersGroupRounded.svg'
import { BaseIcon } from './_base'

export const UsersGroupRoundedIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon = {icon} {...{fontSize,size,...sx}} />
    )
}
